export default __webpack_public_path__ + "static/media/create_experience_new.955cdcf9.png";